export const TRANSIT_EDITOR_TABS = ['general', 'transit-parties', 'house-consignments', 'summary', 'directo', 'logs'] as const

export type Tab = (typeof TRANSIT_EDITOR_TABS)[number]
